/* about processのアニメーション
==================================================== */

/* PC
==================================================== */
/* 画像のホバーアニメーション */
const processListItem = document.querySelectorAll(
  ".about-process__content--pc .about-process__list-item"
);

processListItem?.forEach((item) => {
  item.addEventListener("mouseenter", function () {
    let itemImage = item.querySelector(".about-process__list-item-image");
    gsap.fromTo(
      itemImage,
      {
        duration: 0.45,
        opacity: 0,
        top: "5.5rem",
      },
      {
        duration: 0.45,
        opacity: 1,
        top: "3.6rem",
      }
    );
  });
  item.addEventListener("mouseleave", function () {
    let itemImage = item.querySelector(".about-process__list-item-image");
    gsap.to(itemImage, {
      duration: 0.45,
      opacity: 0,
      top: "5.5rem",
    });
  });
});

/* スクロールでのボーダーアニメーション */
const processBordersPc = document.querySelectorAll(
  ".about-process__content--pc .about-process__list-item-border"
);
processBordersPc?.forEach((border) => {
  gsap.to(border, 1.5, {
    scrollTrigger: {
      trigger: border,
      start: "top bottom",
    },
    delay: 0.2,
    width: "100%",
  });
});

/* SP
==================================================== */
/* 画像のスクロールアニメーション */
const processListItemSp = document.querySelectorAll(
  ".about-process__content--sp .about-process__list-item"
);
const processListSp = document.querySelector(".about-process__content--sp .about-process__right");

function handleScroll() {
  processListItemSp.forEach((item, index) => {
    let itemRect = item.getBoundingClientRect();
    let itemPositionTop = itemRect.top;
    let itemPositionBottom = itemPositionTop + itemRect.height;
    let imagePosition = 80;

    if (itemPositionTop <= imagePosition && itemPositionBottom > imagePosition) {
      const currentActiveImage = document.querySelector(
        ".about-process__content--sp .about-process__list-item-image.is-active"
      );
      if (currentActiveImage !== null) {
        currentActiveImage.classList.remove("is-active");
      }
      const newActiveImage = document.querySelector(
        `.about-process__content--sp .about-process__list-item-image[data-js='${item.dataset.js}']`
      );
      newActiveImage.classList.add("is-active");
    }
  });
}

window.addEventListener("scroll", handleScroll);

/* スクロールでのボーダーアニメーション */
const processBordersSp = document.querySelectorAll(
  ".about-process__content--sp .about-process__list-item-border"
);
processBordersSp?.forEach((border) => {
  gsap.to(border, 1.5, {
    scrollTrigger: {
      trigger: border,
      start: "top 90%",
    },
    width: "calc(100vw - 36px *2)",
  });
});
